import * as React from 'react'
import { Button, CircularProgress } from '@mui/material'
import loadPaystackScript from '../loadPaystackScript'
import CreditIcon from '@mui/icons-material/CreditCardOutlined'

let _window: any

// const buttonStyle = {
//   backgroundColor: "#581818",
//   color: "white",
//   padding: "5px",
//   width: "200px",
//   height: "40px"
// };

interface PayWithPaystackProps {
  embed?: boolean
  text?: string
  className?: string
  metadata?: any
  currency?: string
  plan?: string
  quantity?: string
  subaccount?: string
  transaction_charge?: number
  bearer?: string
  // required fields
  reference?: string
  email: string
  amount: number // in kobo
  paystackkey: string
  callback: Function
  close: Function
  disabled?: boolean
}

interface PayWithPaystackState {
  class: string
  metadata: Object
  currency: string
  plan: string
  quantity: string
  subaccount: string
  transaction_charge: number
  bearer: string
  disabled: boolean
  paystackReady: boolean
}

class PayWithPaystack extends React.Component<
  PayWithPaystackProps,
  PayWithPaystackState
> {
  constructor(props: PayWithPaystackProps) {
    super(props)
    this.state = {
      class: this.props.className || '',
      metadata: this.props.metadata || {},
      currency: this.props.currency || 'NGN',
      plan: this.props.plan || '',
      quantity: this.props.quantity || '',
      subaccount: this.props.subaccount || '',
      transaction_charge: this.props.transaction_charge || 0,
      bearer: this.props.bearer || '',
      disabled: this.props.disabled || false,
      paystackReady: false,
    }
  }

  componentDidMount() {
    _window = window
    loadPaystackScript(() => {
      // Work to do after the library loads.
      this.setState({ paystackReady: true })
      console.log('paystack loaded')
      if (this.props.embed) {
        this.payWithPaystack()
      }
    })
  }

  payWithPaystack = () => {
    const paystackOptions: any = {
      key: this.props.paystackkey,
      email: this.props.email,
      amount: this.props.amount,
      ref: this.props.reference,
      metadata: this.state.metadata,
      callback: (response: any) => {
        this.props.callback(response)
      },
      onClose: () => {
        this.props.close()
      },
      currency: this.state.currency,
      plan: this.state.plan,
      quantity: this.state.quantity,
      subaccount: this.state.subaccount,
      transaction_charge: this.state.transaction_charge,
      bearer: this.state.bearer,
    }
    if (this.props.embed) {
      paystackOptions.container = 'paystackEmbedContainer'
    }
    const handler = _window.PaystackPop.setup(paystackOptions)
    if (!this.props.embed) {
      handler.openIframe()
    }
  }

  render() {
    if (!this.state.paystackReady) {
      return (
        <div style={{ margin: 'auto', marginTop: '50px', textAlign: 'center' }}>
          <CircularProgress size={25} />
        </div>
      )
    }

    return this.props.embed ? (
      <div id="paystackEmbedContainer" />
    ) : (
      <Button
        style={{ height: '55px' }}
        size="large"
        color="primary"
        variant="contained"
        onClick={this.payWithPaystack}
        disabled={this.props.disabled}
        disableElevation={true}
        fullWidth={true}
      >
        <CreditIcon style={{ marginRight: '5px' }} />
        {this.props.text || 'Make Payment'}
      </Button>
    )
  }
}

export default PayWithPaystack
